export const mainColor = '#3f51b5'
export const calendarBorder = '1px solid #ccc'